// extracted by mini-css-extract-plugin
export default {"noticeContainer":"gPb3k","newNotice":"aFA4M","noticeBody":"M7b1j","infoGroup":"zZMQJ","userNickname":"_8UEyD","commentDate":"ClxDr","datepickerWrap":"xq0e5","label":"VKPdX"};